import getTypeImg0 from "@/assets/images/type0@3x.png";
import getTypeImg1 from "@/assets/images/type1@3x.png";
import getTypeImg2 from "@/assets/images/type2@3x.png";
import getTypeImg3 from "@/assets/images/type3@3x.png";
import getTypeImg4 from "@/assets/images/type4@3x.png";
import getTypeImg5 from "@/assets/images/type5@3x.png";
import getTypeImg6 from "@/assets/images/type6@3x.png";
import getTypeImg7 from "@/assets/images/type7@3x.png";
import getTypeImg8 from "@/assets/images/type8@3x.png";
import getTypeImg9 from "@/assets/images/type9@3x.png";
import getTypeImg10 from "@/assets/images/type10@3x.png";
import getTypeImg11 from "@/assets/images/type11@3x.png";
import getTypeImg12 from "@/assets/images/type12@3x.png";

export const changeType = (type: number): number => {
  switch (type) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    case 4:
      return 4;
    case 176:
      return 5;
    case 177:
      return 6;
    case 372:
      return 7;
    case 373:
      return 8;
    case 374:
      return 9;
    case 375:
      return 10;
    case 376:
      return 11;
    case 377:
      return 12;
    default:
      return 9;
  }
};

//获取种养殖图标
export const getTypeImage = (type: number): string => {
  switch (type) {
    case 0:
      return getTypeImg0;
    case 1:
      return getTypeImg1;
    case 2:
      return getTypeImg2;
    case 3:
      return getTypeImg3;
    case 4:
      return getTypeImg4;
    case 5:
      return getTypeImg5;
    case 6:
      return getTypeImg6;
    case 7:
      return getTypeImg7;
    case 8:
      return getTypeImg8;
    case 9:
      return getTypeImg9;
    case 10:
      return getTypeImg10;
    case 11:
      return getTypeImg11;
    case 12:
      return getTypeImg12;
    default:
      return getTypeImg0;
  }
};

// 1 亩 2 平方米
export const areaWithUnit = ({
  area,
  unitType,
}: {
  area?: number | string | null;
  unitType?: number;
}): string => {
  const unit = unitType === 1 ? "亩" : unitType === 2 ? "平方米" : "";
  return area === null || area === undefined ? "" : area + unit;
};

/**
 * @description: 获取星期几
 * @param {String|Number} date: 日期 2021-12-30
 * @return {String}
 */
export const getWeek = (date: string): string => {
  const dateArray = date.split("-");
  const dateMonth = +dateArray[1] - 1;
  const newDate = new Date(
    +dateArray[0],
    parseInt(dateMonth.toString()),
    +dateArray[2]
  );
  return "周" + "日一二三四五六".charAt(newDate.getDay());
};

// 1 - 9 月的的前缀 0
function prefix(str: number | string, separator = 0) {
  return str.toString().replace(/^\d{1}$/, `${separator}${str}`);
}
type FormatDateOption = {
  separator?: string;
  type?: "all" | "date" | "time";
  sep?: string;
};
/**
 * @description: 日期时间格式化
 * @param {String|Number} timestamp: 时间戳，可选，默认当前时间，时间戳格式为 linux 自动转换成 js 时间戳的格式
 * @param {String} separator: 分隔符，默认 -
 * @param {String} type: all、date、time 默认返回所有
 * @param {String} sep: 日期和时间的分隔符，默认空格
 * @return {String}
 */
export const formatDatePicker = (
  timestamp?: number | string,
  { separator = "-", type = "all", sep = " " } = {} as FormatDateOption
): string => {
  const formatTimestamp =
    timestamp && timestamp.toString().length <= 10
      ? `${timestamp}100`
      : timestamp;
  const _date = formatTimestamp ? new Date(+formatTimestamp) : new Date();
  const date = [_date.getFullYear(), _date.getMonth() + 1, _date.getDate()]
    .map((date) => prefix(date))
    .join(separator);
  const time = `${prefix(_date.getHours())}:${prefix(
    _date.getMinutes()
  )}:${prefix(_date.getSeconds())}`;
  return type === "all"
    ? `${date}${sep}${time}`
    : type === "date"
    ? date
    : time;
};

/**
 * @description: 获取当前时间 + 多少分钟
 * @param {Number} minNum: 分钟数
 * @return {String}
 */
export const getCurrentTimeAdd = (minNum: number): string => {
  const date = new Date();
  const min = date.getMinutes();
  date.setMinutes(min + minNum);
  const h = prefix(date.getHours());
  const f = prefix(date.getMinutes());
  const formatdate = h + ":" + f;
  return formatdate;
};
